<div *ngIf="tabs" [ngClass]="{'no-border': noBorder}">
  <div class="d-flex">
    <div *ngFor="let tab of tabs; let i = index"
         [attr.yp-e2e-id]="'page-tab-'+i"
         [routerLink]="tab.path"
         routerLinkActive="tab-active"
         class="flex-column flex-fill tab no-select">
      <p class="h1">{{tab.label}}</p>
      <p>{{tab.info}}</p>
    </div>
  </div>

  <div class="content-box content">
    <ng-content select="[slot='content']"></ng-content>
  </div>

  <div class="d-flex justify-content-end buttons">
    <ng-content select="[slot='buttons']"></ng-content>
  </div>

</div>
